import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TickBoldIcon } from '../../Icons/Miscellaneous/TickBold'
import styles from './ListItemTick.module.scss'

export const ListItemTick: FunctionComponent<Props> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <li className={classnames(styles.listItemTick, className)} {...rest}>
      <TickBoldIcon
        className={styles.listItemTickIcon}
        data-testid="list-tick-icon"
      />
      <span>{children}</span>
    </li>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  className?: string
  children: ReactNode
} & HTMLProps<HTMLLIElement>
